import { INSTANCE_LOG_COLORS } from '../styles/colors';
import { isLocalhostEnvironment } from './utils';
function getInstanceColor(instanceId) {
    return INSTANCE_LOG_COLORS[instanceId % INSTANCE_LOG_COLORS.length];
}
export function maybeConsoleLogInbound(inboundType, parsedInbound, rawInbound, instanceId) {
    if (!isLocalhostEnvironment()) {
        return;
    }
    console.log(`%c[${instanceId}] IN▼ %c${inboundType}: %O %O`, `color: ${getInstanceColor(instanceId)}`, 'color: #888888', parsedInbound.inbound, { raw: rawInbound });
}
export function maybeConsoleLogOutbound(rawOutbound, instanceId) {
    if (!isLocalhostEnvironment()) {
        return;
    }
    const outboundType = rawOutbound.includes(':') ? rawOutbound.substring(0, rawOutbound.indexOf(':') + 1) : '';
    console.log(`%c[${instanceId}] OUT▲ %c${outboundType} %O`, `color: ${getInstanceColor(instanceId)}`, 'color: #888888', { raw: rawOutbound });
}
